var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgVisualDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 4.5,
    fill: "#CAD0D3",
    fillOpacity: 0.3,
    stroke: "#7C90B1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1111 27.7778C13.1111 29 14.1111 30 15.3333 30H24.2222C25.4444 30 26.4444 29 26.4444 27.7778V14.4444H13.1111V27.7778ZM27.5556 11.1111H23.6667L22.5556 10H17L15.8889 11.1111H12V13.3333H27.5556V11.1111Z",
    fill: "#7C90B1"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisualDelete);
export default __webpack_public_path__ + "static/media/visual_delete.0a664510.svg";
export { ForwardRef as ReactComponent };